import { notificationConstants } from "@constants";
import { notificationService } from "@services";
import { message } from "antd";

export const notificationActions = {
  /**
   * 取得推播紀錄列表
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: notificationConstants.GET_ALL_REQUEST
      });

      notificationService.getAll(constructionUuid, condition).then(
        ({ items, total }) => {
          dispatch({
            type: notificationConstants.GET_ALL_SUCCESS,
            constructionUuid,
            items,
            total,
            condition
          });
        },
        error => {
          dispatch({
            type: notificationConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重置推播紀錄列表
   * @returns
   */
  resetAll: () => ({
    type: notificationConstants.RESET_ALL_SUCCESS
  }),
  /**
   * 新增推播
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 推播資訊
   * @param {function} cbSuccess - 成功後的 callback
   *
   * @returns
   */
  create: (constructionUuid, info, cbSuccess) => {
    return (dispatch, getState) => {
      dispatch({
        type: notificationConstants.CREATE_NOTIFICATION_REQUEST
      });
      notificationService.create(constructionUuid, info).then(
        response => {
          dispatch({
            type: notificationConstants.CREATE_NOTIFICATION_SUCCESS
          });

          cbSuccess && cbSuccess();
          message.success(response);
          notificationActions.__getAll(dispatch, getState);
        },
        error => {
          dispatch({
            type: notificationConstants.CREATE_NOTIFICATION_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重置新增推播
   * @returns
   */
  resetCreate: () => ({
    type: notificationConstants.RESET_CREATE_NOTIFICATION_SUCCESS
  }),
  __getAll: (dispatch, getState) => {
    const { notifications } = getState();
    dispatch(
      notificationActions.getAll(
        notifications?.query?.constructionUuid,
        notifications?.query?.condition
      )
    );
  }
};
